import { Domain } from './model'

export const isRestrictedDomains = (domain: Domain) =>
  ['default', 'heat'].includes(domain.name.toLowerCase())

export const filterRestrictedDomains = (domains: Domain[]) =>
  domains.filter((d) => !isRestrictedDomains(d))
